export default function BotaoWrapper({
  ImgName,
  titulo,
  subtitulo,
  cor,
  ImgDesc = "",
}) {
  return (
    <div
      className="
        w-[340px]
        min-h-[420px]
        max-h-[480px]
        bg-white
        rounded-3xl
        overflow-hidden
        transition-transform
        duration-300
        flex
        flex-col
      "
    >
      <div className="w-full h-[180px] bg-gray-100 relative shrink-0">
        <img
          src={ImgName}
          alt={ImgDesc}
          className="
            w-full
            h-full
            object-cover
          "
        />

        <div
          className="
            absolute
            inset-0
            bg-black/5
          "
        />
      </div>

      <div
        className="
          flex
          flex-col
          gap-3
          p-6
          text-center
          flex-1
          justify-center
          text-white
        "
        style={{
          backgroundColor: cor,
        }}
      >
        <h2
          className="
            text-3xl
            text-start
            font-bold
            text-white
            leading-tight
            line-clamp-2
          "
        >
          {titulo}
        </h2>

        <p
          className="
            text-lg
            text-white
            leading-snug
            text-start
            line-clamp-3
          "
        >
          {subtitulo}
        </p>
      </div>
    </div>
  );
}
